var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("RenderMoneyColumnValue", { attrs: { value: _vm.invoiceValue } }),
      _vm._v(" |\n  "),
      _c("RenderPanoramaInvoiceStatus", {
        attrs: { "panorama-invoice-status": _vm.panoramaInvoiceStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }